/* eslint-disable */
import * as Types from '../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../features/attachments/Attachments.generated.js';
import { AddressDetails__AddressFragmentDoc } from '../features/addresses/Addresses.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MeQuery = { viewer?: { __typename: 'Viewer', id: string, description: string, email: any, familyname: string, firstname: string, fullname: string, isAdmin: boolean, isMeister: boolean, locale: string, organisationPermissions: Array<Types.PermissionName>, categories: Array<string>, title: Types.Salutation, type: Types.UserType, viewerHasPushNotificationToken: boolean, viewerPersonalRefToken: string, viewerRefToken: string, website?: string | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, viewerBranding: { __typename: 'ViewerBranding', id: string, sidebarTheme?: { __typename: 'ViewerBrandingTheme', id: string, type: Types.BrandingThemeType, colorBackground: string, colorText: string } | null, topbarTheme?: { __typename: 'ViewerBrandingTheme', id: string, type: Types.BrandingThemeType, colorBackground: string, colorText: string } | null, sidebarTopLogo?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, sidebarBottomLogo?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, topbarLeftLogo?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, topbarRightLogo?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, dashboardLeftTopAd?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, dashboardRightTopAd?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, dashboardSideTopAd?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null }, organisation: { __typename: 'ViewerOrganisation', id: string, description: string, isClientOrganisation: boolean, isCraftsmanOrganisation: boolean, isMeister: boolean, organisationType: Types.OrganisationType, title: string, website: string, categories: Array<string>, capabilities: Array<Types.Capabilities>, enabledIntegrationIds: Array<Types.IntegrationId>, contactPerson?: { __typename: 'Person', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string, label: string }>, projectRoles: Array<{ __typename: 'ProjectRole', id: string, internalName: string, label: string }>, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, configurations: { __typename: 'OrganisationConfigurations', id: string, projectClientFilters?: { __typename: 'ProjectClientFilters', businessPartnerRolesAll?: Array<string> | null, businessPartnerRolesExclude?: Array<string> | null, tagsExclude?: Array<string> | null } | null } }, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string, label: string }> } | null };

export type AuthUpdateUserMutationVariables = Types.Exact<{
  user: Types.UserModifyInput;
}>;


export type AuthUpdateUserMutation = { updateUser: { __typename: 'UpdateUserResult', user: { __typename: 'Viewer', id: string, description: string, email: any, familyname: string, firstname: string, fullname: string, isAdmin: boolean, isMeister: boolean, locale: string, organisationPermissions: Array<Types.PermissionName>, categories: Array<string>, title: Types.Salutation, type: Types.UserType, viewerHasPushNotificationToken: boolean, viewerPersonalRefToken: string, viewerRefToken: string, website?: string | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, viewerBranding: { __typename: 'ViewerBranding', id: string, sidebarTheme?: { __typename: 'ViewerBrandingTheme', id: string, type: Types.BrandingThemeType, colorBackground: string, colorText: string } | null, topbarTheme?: { __typename: 'ViewerBrandingTheme', id: string, type: Types.BrandingThemeType, colorBackground: string, colorText: string } | null, sidebarTopLogo?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, sidebarBottomLogo?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, topbarLeftLogo?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, topbarRightLogo?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, dashboardLeftTopAd?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, dashboardRightTopAd?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, dashboardSideTopAd?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null }, organisation: { __typename: 'ViewerOrganisation', id: string, description: string, isClientOrganisation: boolean, isCraftsmanOrganisation: boolean, isMeister: boolean, organisationType: Types.OrganisationType, title: string, website: string, categories: Array<string>, capabilities: Array<Types.Capabilities>, enabledIntegrationIds: Array<Types.IntegrationId>, contactPerson?: { __typename: 'Person', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string, label: string }>, projectRoles: Array<{ __typename: 'ProjectRole', id: string, internalName: string, label: string }>, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, configurations: { __typename: 'OrganisationConfigurations', id: string, projectClientFilters?: { __typename: 'ProjectClientFilters', businessPartnerRolesAll?: Array<string> | null, businessPartnerRolesExclude?: Array<string> | null, tagsExclude?: Array<string> | null } | null } }, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string, label: string }> } } };

export type PhoneFragment = { __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string };

export type ViewerShapeFragment = { __typename: 'Viewer', id: string, description: string, email: any, familyname: string, firstname: string, fullname: string, isAdmin: boolean, isMeister: boolean, locale: string, organisationPermissions: Array<Types.PermissionName>, categories: Array<string>, title: Types.Salutation, type: Types.UserType, viewerHasPushNotificationToken: boolean, viewerPersonalRefToken: string, viewerRefToken: string, website?: string | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, viewerBranding: { __typename: 'ViewerBranding', id: string, sidebarTheme?: { __typename: 'ViewerBrandingTheme', id: string, type: Types.BrandingThemeType, colorBackground: string, colorText: string } | null, topbarTheme?: { __typename: 'ViewerBrandingTheme', id: string, type: Types.BrandingThemeType, colorBackground: string, colorText: string } | null, sidebarTopLogo?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, sidebarBottomLogo?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, topbarLeftLogo?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, topbarRightLogo?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, dashboardLeftTopAd?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, dashboardRightTopAd?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, dashboardSideTopAd?: { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null }, organisation: { __typename: 'ViewerOrganisation', id: string, description: string, isClientOrganisation: boolean, isCraftsmanOrganisation: boolean, isMeister: boolean, organisationType: Types.OrganisationType, title: string, website: string, categories: Array<string>, capabilities: Array<Types.Capabilities>, enabledIntegrationIds: Array<Types.IntegrationId>, contactPerson?: { __typename: 'Person', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string, label: string }>, projectRoles: Array<{ __typename: 'ProjectRole', id: string, internalName: string, label: string }>, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, configurations: { __typename: 'OrganisationConfigurations', id: string, projectClientFilters?: { __typename: 'ProjectClientFilters', businessPartnerRolesAll?: Array<string> | null, businessPartnerRolesExclude?: Array<string> | null, tagsExclude?: Array<string> | null } | null } }, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string, label: string }> };

export type ContactPersonFragment = { __typename: 'Person', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> };

export type CrmContactPersonFragment = { __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> };

export type CrmUserFragment = { __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, email: any, categories: Array<string>, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type AuthOrganisationFragment = { __typename: 'ViewerOrganisation', id: string, description: string, isClientOrganisation: boolean, isCraftsmanOrganisation: boolean, isMeister: boolean, organisationType: Types.OrganisationType, title: string, website: string, categories: Array<string>, capabilities: Array<Types.Capabilities>, enabledIntegrationIds: Array<Types.IntegrationId>, contactPerson?: { __typename: 'Person', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string, label: string }>, projectRoles: Array<{ __typename: 'ProjectRole', id: string, internalName: string, label: string }>, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, configurations: { __typename: 'OrganisationConfigurations', id: string, projectClientFilters?: { __typename: 'ProjectClientFilters', businessPartnerRolesAll?: Array<string> | null, businessPartnerRolesExclude?: Array<string> | null, tagsExclude?: Array<string> | null } | null } };

export type AuthBrandingThemeFragment = { __typename: 'ViewerBrandingTheme', id: string, type: Types.BrandingThemeType, colorBackground: string, colorText: string };

export type AuthBrandingSlotFragment = { __typename: 'ViewerBrandingSlot', id: string, title: string, url: string, attachment?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null };

export const PhoneFragmentDoc = gql`
    fragment Phone on Phone {
  id
  main
  type
  number
}
    `;
export const AuthBrandingThemeFragmentDoc = gql`
    fragment AuthBrandingTheme on ViewerBrandingTheme {
  id
  type
  colorBackground
  colorText
}
    `;
export const AuthBrandingSlotFragmentDoc = gql`
    fragment AuthBrandingSlot on ViewerBrandingSlot {
  id
  title
  url
  attachment {
    ...AttachmentSnapshot
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export const ContactPersonFragmentDoc = gql`
    fragment ContactPerson on Person {
  id
  title
  description
  website
  isMeister
  familyname
  firstname
  fullname
  locale
  categories
}
    `;
export const AuthOrganisationFragmentDoc = gql`
    fragment AuthOrganisation on ViewerOrganisation {
  id
  description
  isClientOrganisation
  isCraftsmanOrganisation
  isMeister
  organisationType
  title
  website
  categories
  capabilities
  contactPerson {
    id
    ...ContactPerson
  }
  logo {
    ...AttachmentSnapshot
  }
  roles {
    id
    internalName
    label
  }
  projectRoles {
    id
    internalName
    label
  }
  billingAddress {
    ...AddressDetails__Address
  }
  branchAddress {
    ...AddressDetails__Address
  }
  enabledIntegrationIds
  configurations {
    id
    projectClientFilters {
      businessPartnerRolesAll
      businessPartnerRolesExclude
      tagsExclude
    }
  }
}
    ${ContactPersonFragmentDoc}
${AttachmentSnapshotFragmentDoc}
${AddressDetails__AddressFragmentDoc}`;
export const ViewerShapeFragmentDoc = gql`
    fragment ViewerShape on Viewer {
  id
  description
  email
  familyname
  firstname
  fullname
  isAdmin
  isMeister
  locale
  organisationPermissions
  categories
  title
  type
  viewerHasPushNotificationToken
  viewerPersonalRefToken
  viewerRefToken
  website
  phones {
    id
    ...Phone
  }
  avatar {
    ...AttachmentSnapshot
  }
  viewerBranding {
    id
    sidebarTheme {
      id
      ...AuthBrandingTheme
    }
    topbarTheme {
      id
      ...AuthBrandingTheme
    }
    sidebarTopLogo {
      id
      ...AuthBrandingSlot
    }
    sidebarBottomLogo {
      id
      ...AuthBrandingSlot
    }
    topbarLeftLogo {
      id
      ...AuthBrandingSlot
    }
    topbarRightLogo {
      id
      ...AuthBrandingSlot
    }
    dashboardLeftTopAd {
      id
      ...AuthBrandingSlot
    }
    dashboardRightTopAd {
      id
      ...AuthBrandingSlot
    }
    dashboardSideTopAd {
      id
      ...AuthBrandingSlot
    }
  }
  organisation {
    id
    ...AuthOrganisation
  }
  roles {
    id
    internalName
    label
  }
}
    ${PhoneFragmentDoc}
${AttachmentSnapshotFragmentDoc}
${AuthBrandingThemeFragmentDoc}
${AuthBrandingSlotFragmentDoc}
${AuthOrganisationFragmentDoc}`;
export const CrmContactPersonFragmentDoc = gql`
    fragment CrmContactPerson on CrmPerson {
  id
  title
  description
  website
  isMeister
  familyname
  firstname
  fullname
  locale
  categories
}
    `;
export const CrmUserFragmentDoc = gql`
    fragment CrmUser on CrmPerson {
  id
  title
  description
  website
  isMeister
  familyname
  firstname
  fullname
  locale
  email
  phones {
    id
    ...Phone
  }
  avatar {
    ...AttachmentSnapshot
  }
  categories
}
    ${PhoneFragmentDoc}
${AttachmentSnapshotFragmentDoc}`;
export const MeDocument = gql`
    query Me {
  viewer {
    id
    ...ViewerShape
  }
}
    ${ViewerShapeFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const AuthUpdateUserDocument = gql`
    mutation AuthUpdateUser($user: UserModifyInput!) {
  updateUser(user: $user) {
    user {
      ...ViewerShape
    }
  }
}
    ${ViewerShapeFragmentDoc}`;
export type AuthUpdateUserMutationFn = Apollo.MutationFunction<AuthUpdateUserMutation, AuthUpdateUserMutationVariables>;

/**
 * __useAuthUpdateUserMutation__
 *
 * To run a mutation, you first call `useAuthUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authUpdateUserMutation, { data, loading, error }] = useAuthUpdateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useAuthUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<AuthUpdateUserMutation, AuthUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthUpdateUserMutation, AuthUpdateUserMutationVariables>(AuthUpdateUserDocument, options);
      }
export type AuthUpdateUserMutationHookResult = ReturnType<typeof useAuthUpdateUserMutation>;
export type AuthUpdateUserMutationResult = Apollo.MutationResult<AuthUpdateUserMutation>;
export type AuthUpdateUserMutationOptions = Apollo.BaseMutationOptions<AuthUpdateUserMutation, AuthUpdateUserMutationVariables>;